/* eslint-disable react/require-default-props,react/destructuring-assignment,react/prop-types */
import React, { Component } from 'react';
import PropTypes from 'prop-types';
import CSSModules from 'react-css-modules';
import classNames from 'classnames';
import styles from './index.styl';

/*
 * The only reason making this comp stateful is that it's impossible to use refs with stateless one
 * https://github.com/facebook/react/issues/4936
 * */
/* eslint-disable react/prefer-stateless-function */
class Content extends Component {
  shouldComponentUpdate(nextProps) {
    return this.props.children !== nextProps.children;
  }

  render() {
    const {
      children,
      className,
      empty,
      fullHeight,
      style,
      refLink,
      onScroll,
    } = this.props;
    return (
      <div
        {...{ children, className, style, ref: refLink, onScroll }}
        styleName={classNames(
          'content',
          { 'content--empty': empty },
          { 'content--fullHeight': fullHeight },
        )}
        // eslint-disable-next-line jsx-a11y/no-noninteractive-tabindex
        tabIndex="0"
      />
    );
  }
}

Content.propTypes = {
  children: PropTypes.oneOfType([
    PropTypes.element,
    PropTypes.node,
    PropTypes.number,
    PropTypes.string,
  ]),
  className: PropTypes.string,
  empty: PropTypes.bool,
  fullHeight: PropTypes.bool,
  style: PropTypes.object,
  onScroll: PropTypes.func,
};

export default CSSModules(Content, styles, { allowMultiple: true });



// WEBPACK FOOTER //
// ./src/components/ContentArea/Content.jsx